import { Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import QuoteItem from "./QuoteItem";
import classes from "./QuoteList.module.css";

const sortQuotes = (quotes, ascending) => {
  return quotes.sort((quoteA, quoteB) => {
    if (ascending) {
      return quoteA.id > quoteB.id ? 1 : -1;
    } else {
      return quoteA.id < quoteB.id ? 1 : -1;
    }
  });
};

const QuoteList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const querryParam = new URLSearchParams(location.search);
  const isSortingAscending = querryParam.get("sort") === "asc";

  const sortedQuotes = sortQuotes(props.quotes, isSortingAscending);

  const sortHandler = () => {
    navigate("/quotes?sort=" + (isSortingAscending ? "desc" : "asc"));

    console.log(querryParam.getAll(location.search));
    console.log(isSortingAscending);
  };
  return (
    <Fragment>
      <div className={classes.sorting}>
        {" "}
        <button onClick={sortHandler}>
          Sort {isSortingAscending ? "descending" : "ascending"}
        </button>
      </div>

      <ul className={classes.list}>
        {sortedQuotes.map((quote) => (
          <QuoteItem
            key={quote.id}
            id={quote.id}
            author={quote.author}
            text={quote.text}
          />
        ))}
      </ul>
    </Fragment>
  );
};

export default QuoteList;
